import {
  CompensationMethod,
  ReturnTypeEnum,
} from "@redotech/redo-model/return";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum GetReturnsByOrderIdErrors {
  UNAUTHORIZED = "UNAUTHORIZED",
  INVALID_ORDER_ID = "INVALID_ORDER_ID",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

const ReturnedProductSchema = z.object({
  _id: z.string(),
  images: z.array(z.string().nullable()),
  status: z.string(),
  quantity: z.number(),
  strategy: z.string(),
  price: z.string(),
  variant_title: z.string(),
  variant_id: z.string(),
  product_title: z.string(),
  line_item_id: z.string(),
  rejectMessage: z.string().nullish(),
});
export const ReturnedProduct: z.ZodType<ReturnedProduct> =
  ReturnedProductSchema;
export interface ReturnedProduct
  extends z.infer<typeof ReturnedProductSchema> {}

// Create a DisplayReturn schema that only includes fields needed for the returns UI
const DisplayReturnSchema = z.object({
  _id: z.string(),
  createdAt: z.union([z.string(), z.date()]),
  updatedAt: z.union([z.string(), z.date()]),
  status: z.string(),
  currency: z.string(),
  type: createEnum(ReturnTypeEnum),
  /**
   *  @deprecated use returnTypes instead
   */
  returnType: createEnum(CompensationMethod).nullish(),
  returnTypes: z.array(createEnum(CompensationMethod)),
  products: z.array(ReturnedProductSchema),
  draftOrderURL: z.string().optional(),
  labelDeductedFromCredit: z.boolean().nullish(), // TODO: required
  isManualLabel: z.boolean().nullish(),
});
export const DisplayReturn: z.ZodType<DisplayReturn> = DisplayReturnSchema;
export interface DisplayReturn extends z.infer<typeof DisplayReturnSchema> {}

export const getReturnsByOrderId = {
  name: "getReturnsByOrderId" as const,
  input: z.object({ orderId: z.string() }),
  output: z.object({ returns: z.array(DisplayReturnSchema) }),
};
